import React, { useRef, useState } from "react";
import Draggable from "react-draggable";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import { handleDraggableModalState } from "@redux/actionCreators/draggableModal";

export function DraggableWrapper({ children }) {
  const draggableModalState = useSelector(state => state?.draggableModalReducer, shallowEqual);

  const [bounds, setBounds] = useState({
    left: 0,
    top: 0,
    bottom: 0,
    right: 0
  });
  const draggleRef = useRef(null);

  const onStart = (_event, uiData) => {
    const { clientWidth, clientHeight } = window.document.documentElement;
    const targetRect = draggleRef.current?.getBoundingClientRect();
    if (!targetRect) {
      return;
    }
    setBounds({
      left: -targetRect.left + uiData.x,
      right: clientWidth - (targetRect.right - uiData.x),
      top: -targetRect.top + uiData.y,
      bottom: clientHeight - (targetRect.bottom - uiData.y)
    });
  };

  return (
    <Draggable
      disabled={draggableModalState.isModalDisabled}
      bounds={bounds}
      onStart={(event, uiData) => onStart(event, uiData)}
    >
      <div ref={draggleRef}>{children}</div>
    </Draggable>
  );
}

export function DraggableTitle({ title }) {
  const dispatch = useDispatch();

  const draggableModalState = useSelector(state => state?.draggableModalReducer, shallowEqual);
  return (
    <div
      onMouseOver={() => {
        if (draggableModalState.isModalDisabled) {
          dispatch(handleDraggableModalState(false));
        }
      }}
      onMouseOut={() => {
        dispatch(handleDraggableModalState(true));
      }}
      style={{
        width: "100%",
        cursor: "move"
      }}
    >
      {title}
    </div>
  );
}